import type { CSSProperties, ReactNode } from 'react'

import { useTheme } from '../../theme/ThemeContext'
import {
  loginAuthCardBodyClass,
  loginAuthCardGlassOverlayClass,
  loginAuthCardRootClass,
} from './loginSurfaceStyles'

type RootProps = {
  children: ReactNode
  className?: string
  style?: CSSProperties
}

/**
 * 登录表单卡：`LoginPage` PC 与移动端共用同一组件；样式由 {@link loginAuthCardRootClass}
 * / {@link LoginAuthCardBody} 统一，断点仅在「大屏限定 max-h + 内部滚动」等与窄屏自适应高度上做差异。
 */
export function LoginAuthCard({ children, className, style }: RootProps) {
  const { theme } = useTheme()
  const isGlass = theme === 'glass'
  return (
    <div
      className={[loginAuthCardRootClass(theme), className].filter(Boolean).join(' ')}
      style={style}
    >
      {isGlass ? (
        <div className={loginAuthCardGlassOverlayClass} aria-hidden />
      ) : null}
      {children}
    </div>
  )
}

type BodyProps = {
  children: ReactNode
  className?: string
}

/** 卡内表单区（与 {@link loginAuthCardBodyClass} 一致；移动端随内容增高） */
export function LoginAuthCardBody({ children, className }: BodyProps) {
  return (
    <div className={[loginAuthCardBodyClass, className].filter(Boolean).join(' ')}>
      {children}
    </div>
  )
}
